import { Box, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import { AboutThisPage, PageHeader } from '../../ui/primitives';
import HouseDefaultsTab from './HouseDefaultsTab';
import IntegrationsTab from './IntegrationsTab';
import RolesTab from './RolesTab';
import RulesTab from './RulesTab';
import UsersTab from './UsersTab';

export default function SettingsPage() {
  const [tab, setTab] = useState(0);
  return (
    <>
      <PageHeader
        title="Registry settings"
        subtitle="Tenant-level configuration: rules, roles, integrations, and the defaults and branding every new fund starts from."
      />
      <AboutThisPage>
        <p>
          Everything on this page is per tenant. That is what lets another manager run their own
          register on the platform with their own rules, bank and ATO identifiers, staff and
          branding, completely separate from Fides&apos;s data.
        </p>
      </AboutThisPage>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs value={tab} onChange={(_event, next) => setTab(next)} variant="scrollable">
          <Tab label="Rules" />
          <Tab label="Users" />
          <Tab label="Roles & permissions" />
          <Tab label="Integrations" />
          <Tab label="Fund defaults & branding" />
        </Tabs>
      </Box>
      {tab === 0 && <RulesTab />}
      {tab === 1 && <UsersTab />}
      {tab === 2 && <RolesTab />}
      {tab === 3 && <IntegrationsTab />}
      {tab === 4 && <HouseDefaultsTab />}
    </>
  );
}
